exports.components = {
  "component---src-components-templates-terms-and-conditions-template-jsx": () => import("./../../../src/components/templates/terms-and-conditions-template.jsx" /* webpackChunkName: "component---src-components-templates-terms-and-conditions-template-jsx" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-contacto-jsx": () => import("./../../../src/pages/contacto.jsx" /* webpackChunkName: "component---src-pages-contacto-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

